import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { TextField, CircularProgress } from "@mui/material";
import axios from "axios";
import { API_BASE } from "../apiBase";
import { useNavigate } from "react-router-dom";
import "./Members_data.scss";

const Member_data = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Store the search term

  const navigate = useNavigate();

  // Fetch all members (no pagination)
  const fetchMembers = async (searchTerm = "") => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE}/fetch_all_member_data.php?search=${encodeURIComponent(searchTerm)}`
      );
      const { members } = response.data; // Assume API returns all members

      const mappedData = members.map((member) => ({
        id: member.member_no,
        name: member.member_name,
        phone: member.member_mobile,
        city: member.city,
        father: member.father_name,
        position:
          member.position === "chairman"
            ? "தலைவர்"
            : member.position === "vice_president"
            ? "துணை தலைவர்"
            : member.position === "porulaalar"
            ? "பொருளாளர்"
            : member.position === "secretary"
            ? "செயலாளர்"
            : member.position === "joint_secretary"
            ? "இணைச் செயலாளர்"
            : member.position === "ec_member"
            ? "நிர்வாக குழு உறுப்பினர்"
            : "உறுப்பினர்",
      }));

      setMembers(mappedData); // Set the fetched members
    } catch (error) {
      console.error("Error fetching members:", error);
    }
    setLoading(false);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    fetchMembers(searchTerm); // Fetch all members on initial load or search
  }, [searchTerm]);

  const handleRowClick = (params) => {
    navigate(`/members-details/${params.id}`);
  };

  const columns = [
    { field: "id", headerName: "உறுப்பினர் எண்", width: 150, headerClassName: "bold-header" },
    { field: "name", headerName: "பெயர்", width: 200, headerClassName: "bold-header" },
    { field: "phone", headerName: "மொபைல் நம்பர்", width: 200, headerClassName: "bold-header" },
    { field: "city", headerName: "ஊர்", width: 150, headerClassName: "bold-header" },
    { field: "father", headerName: "தந்தை பெயர்", width: 200, headerClassName: "bold-header" },
    { field: "position", headerName: "பொறுப்பு", width: 186, headerClassName: "bold-header" },
  ];

  return (
    <div className="member_data_container" style={{ height: "70vh", width: "85%", marginTop: "1rem", margin: "0 auto" }}>
      <TextField
        label="search"
        variant="outlined"
        value={searchTerm}
        placeholder="உறுப்பினர் எண் | பெயர் | நம்பர் | ஊர் | தந்தை(பெயர் | உறுப்பினர் எண்)"
        onChange={handleSearchChange}
        style={{ marginTop: "1rem", marginBottom: "1rem", width: "100%" }}
      />

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <CircularProgress />
        </div>
      ) : (
        <DataGrid
          className="custom-data-grid"
          rows={members}
          columns={columns}
          onRowDoubleClick={handleRowClick}
        />
      )}
    </div>
  );
};

export default Member_data;
